export default __webpack_public_path__ + "static/media/problem3.3d8c5d55.png";